import Vue from "vue";
import App from "./App.vue";

import router from "./router/routes";
import axios from "axios";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import MintUI from "mint-ui";
import Vant from "vant";
import { Toast, Notify, Overlay, PullRefresh, Dialog } from "vant";
import "mint-ui/lib/style.css";
import "vant/lib/index.css";

import { getOpenId, getOpenIdNew } from "./apis/myGarage";
import { loginByWx } from "./apis/owner";
import { queryString } from "./utils/getCodeUrl";
import { queryByWx } from "./apis/carOwner";

import VConsole from 'vconsole';

Vue.use(ElementUI);
Vue.use(MintUI);
Vue.use(Vant);
Vue.use(Notify, Toast, PullRefresh);
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$notify = Notify;
Vue.prototype.$overlay = Overlay;
Vue.prototype.$toast = Toast;
Toast.setDefaultOptions({ duration: 3000 });

// vconsole
// import './utils/vconsoleUtil.js'

router.beforeEach((to, from, next) => {
  if (!from.name) {
    localStorage.setItem("showModal", 0);
  }
  // localStorage.setItem('openid','okzo_w9ROuacQt15zqmI1cDZI8xQ')
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  let wxopenid = localStorage.getItem("openid");
  let feedBackOpenId = localStorage.getItem("feedBackOpenId");

  let whiteList = ["/store", "/insurance", "/download"];
  localStorage.setItem("site_open_id_dev", "okzo_ww-1z5QD4Cy7-N0U5vUmAmo");
  //   let openidKey = 'site_open_id_'+process.env.VUE_APP_NAME
  //   let openid = localStorage[openidKey];
  console.log("openid===测试", wxopenid);
  if (to.path == "/ownercode") {
    //车主码进来
    let code = queryString("code");
    console.log("车主码code==", code);
    if (code) {
      getloginByWx(next, { wxcode: code });
    } else {
      if (wxopenid && wxopenid != undefined && wxopenid != "undefined") {
        getloginByWx(next, { openId: wxopenid });
      } else {
        let local = window.location.href;
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          process.env.VUE_APP_APPID +
          "&redirect_uri=" +
          encodeURIComponent(local) +
          "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
      }
    }
  } else if (to.path == "/") {
    //我的车库
    let code = queryString("code");
    if (code) {
      let param = { wxcode: code };
      getqueryByWx(next, param);
    } else {
      // if(to.params.phone){
      //     next()
      // }else{
      //     let local = window.location.href;
      //     // window.location.href = 'http://192.168.150.38/gzh-test/?code=sdfgsdf4g65sdf4g56sdf'
      //     window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + process.env.VUE_APP_APPID + '&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      //     return
      // }

      if (wxopenid && wxopenid != undefined && wxopenid != "undefined") {
        let param = {};
        if (to.params.phone) {
          param = {
            openId: wxopenid,
            phone: to.params.phone,
          };
        } else {
          param = { openId: wxopenid };
        }

        console.log("op=", wxopenid != "undefined", param);
        getqueryByWx(next, param);
      } else {
        let local = window.location.href;
        // window.location.href = 'http://192.168.150.38/gzh-test/?code=sdfgsdf4g65sdf4g56sdf'
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          process.env.VUE_APP_APPID +
          "&redirect_uri=" +
          encodeURIComponent(local) +
          "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
        return;
      }
    }
    return;
  } else if (to.path == "/feedbackCenter") {
    console.log("帮助中心");
    if (
      feedBackOpenId == null ||
      typeof feedBackOpenId == "undefined" ||
      feedBackOpenId == ""
    ) {
      let code = "";
      let url = window.location.href;
      let param = url.split("?")[1];
      // 截图微信返回code
      if (param) {
        let startIndex = param.indexOf("=");
        let endIndex = param.indexOf("&");
        if (endIndex > -1) {
          code = param.substring(startIndex + 1, endIndex);
        } else {
          code = param.substring(startIndex + 1, param.length);
        }
      }

      let local = window.location.href;
      if (code == null || code == "") {
        // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx071a2ba4872a9a8f&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&&state=STATE#wechat_redirect'
        // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx071a2ba4872a9a8f&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
        // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx4e998e7ec29a0d78&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          process.env.VUE_APP_APPID +
          "&redirect_uri=" +
          encodeURIComponent(local) +
          "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
      } else {
        console.log("微信code===", code);
        var data = {
          codeParam: code,
        };
        getOpenIdNew(code)
          .then((response) => {
            const data = response.data;
            console.log("queryOpenid=", data);
            if (data) {
              localStorage.setItem("feedBackOpenId", data);
              localStorage.setItem("openid", data);
              store.commit("getOpenId", data);
            }
            localStorage.setItem("feedBackOpenId", data);
            localStorage.setItem("openid", data);
            store.commit("getOpenId", data);
            next();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }  else {
      next();
    }
  } else if (whiteList.indexOf(to.path) !== -1) {
    next();
  } else if (
    wxopenid == null ||
    typeof wxopenid == "undefined" ||
    wxopenid == ""
  ) {
    var code = "";
    let url = window.location.href;
    let param = url.split("?")[1];
    // 截图微信返回code
    if (param) {
      let startIndex = param.indexOf("=");
      let endIndex = param.indexOf("&");
      if (endIndex > -1) {
        code = param.substring(startIndex + 1, endIndex);
      } else {
        code = param.substring(startIndex + 1, param.length);
      }
    }

    let local = window.location.href;
    if (code == null || code == "") {
      // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx071a2ba4872a9a8f&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&&state=STATE#wechat_redirect'
      // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx071a2ba4872a9a8f&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx4e998e7ec29a0d78&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      window.location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        process.env.VUE_APP_APPID +
        "&redirect_uri=" +
        encodeURIComponent(local) +
        "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
    } else {
      console.log("微信code===", code);
      let data = {
        codeParam: code,
      };
      getOpenIdNew(code)
        .then((response) => {
          const data = response.data;
          console.log("queryOpenid=", data);
          if (data) {
            localStorage.setItem("openid", data);
            store.commit("getOpenId", data);
          }
          localStorage.setItem("openid", data);
          store.commit("getOpenId", data);
          next();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  } else {
    next();
  }
});

function getqueryByWx(next, params) {
  queryByWx(params).then((res) => {
    if (res.data.openId) {
      localStorage.setItem("openid", res.data.openId);
    }

    if (res.status == 2001) {
      next({ path: "/phonelogin?url=myGarage" });
    } else if (res.status == 2004) {
      localStorage.clear();
      window.location.reload();
    } else if (res.status == 2003) {
      window.location.href = window.location.origin + window.location.pathname;
    } else if (res.status !== 0) {
      Notify({ type: "warning", message: res.msg });
      next({
        path: "/phonelogin?url=myGarage",
      });
    } else {
      next();
    }
  });
}

function getloginByWx(next, params) {
  loginByWx(params).then((res) => {
    if (res.status == 2001) {
      // store.state.ownerStates = res.status;
      store.commit("setOwnerStates", res.status);
      if (res.data) {
        localStorage.setItem("openid", res.data.openId);
      }

      next({ path: "/phonelogin?url=ownerinfo" });
    }
    if (res.status == 2003) {
      Toast({
        message: res.msg,
      });
    }
    if (res.status == 2004) {
      localStorage.clear();
      window.location.reload();
    }

    if (res.status == 0) {
      // store.state.ownerInfo = res.data.CarOwnerInfo;
      // store.state.ownerStates = res.data.carOwnerCode;
      store.commit("setOwnerInfo", res.data.CarOwnerInfo);
      store.commit("setOwnerStates", res.data.carOwnerCode);
      console.log("openId==", res.data.carwx.openId);
      localStorage.setItem("openid", res.data.carwx.openId);
      if (res.data.carOwnerCode == 0) {
        store.commit("setOwnerInfo", {
          phone: res.data.carwx.wxPhone,
          sex: "0",
        });

        next({ path: "/ownerinfo" });
      }
      if (res.data.carOwnerCode == 1) {
        next({ path: "/ownerinfo" });
      }
      if (res.data.carOwnerCode == 2) {
        next();
      }
    }
    // next()
  });
}

//全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
Vue.directive("real-img", async function (el, binding) {
  //指令名称为：real-img
  let imgURL = binding.value; //获取图片地址
  if (imgURL) {
    let exist = await imageIsExist(imgURL);
    if (exist) {
      el.setAttribute("src", imgURL);
    }
  }
});

/**
 * 检测图片是否存在
 * @param url
 */
let imageIsExist = function (url) {
  return new Promise((resolve) => {
    var img = new Image();
    if (url.indexOf("default") > -1) {
      resolve(false);
      img = null;
    } else {
      img.onload = function () {
        if (this.complete == true) {
          resolve(true);
          img = null;
        }
      };
      img.onerror = function () {
        resolve(false);
        img = null;
      };
    }
    img.src = url;
  });
};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
